import { twMerge } from "tailwind-merge";
import { Button } from "../../Atoms/Button";

const DOCUMENT_CONTENTS = {
  Cartilha_Vistoriador: {
    title: "Cartilha do Vistoriador",
    description:
      "Manual completo com procedimentos, orientações e boas práticas para a realização de vistorias veiculares.",
    icon: (
      <img
        src="/assets/svgs/icon-cartilha-vistoriador.svg"
        alt="Ícone de Documento"
      />
    ),
  },
  Missao_Visao_Valores: {
    title: "Missão, Visão e Valores",
    description:
      "Conheça os princípios e diretrizes que norteiam nossa empresa e guiam nossas ações.",
    icon: <img src="/assets/svgs/icon-missao.svg" alt="Ícone de Documento" />,
  },
  Cartilha_Amarela: {
    title: "Cartilha Amarela",
    description:
      "Orientações importantes sobre prevenção e combate ao assédio no ambiente de trabalho.",
    icon: (
      <img
        src="/assets/svgs/icon-cartilha-amarela.svg"
        alt="Ícone de Documento"
      />
    ),
  },
  Regulamento_Interno: {
    title: "Regulamento Interno",
    description:
      "Normas e procedimentos internos da empresa para consulta dos colaboradores.",
    icon: (
      <img
        src="/assets/svgs/icon-regulamento-interno.svg"
        alt="Ícone de Documento"
      />
    ),
  },
};

interface ICorporateDocumentationCardProps extends React.ComponentProps<"div"> {
  docType:
    | "Cartilha_Vistoriador"
    | "Missao_Visao_Valores"
    | "Cartilha_Amarela"
    | "Regulamento_Interno";
}

export const CorporateDocumentationCard = ({
  className,
  docType,
  ...rest
}: ICorporateDocumentationCardProps) => {
  const { title, description, icon: Icon } = DOCUMENT_CONTENTS[docType];

  const projectEnvRaw = (process.env.REACT_APP_PROJECT || "").trim();
  const projectUpper = projectEnvRaw.toUpperCase();
  const projectLower = projectEnvRaw.toLowerCase();

  const baseMap: Record<string, string> = {
    Cartilha_Vistoriador: "CARTILHA_DO_VISTORIADOR",
    Missao_Visao_Valores: "MISSAO_VISAO_E_VALORES",
    Cartilha_Amarela: "CARTILHA_AMARELA",
    Regulamento_Interno: "REGULAMENTO_INTERNO",
  };

  const getHref = () => {
    if (docType === "Cartilha_Amarela") {
      return `/assets/docs/CARTILHA_AMARELA.pdf`;
    }
    const base = baseMap[docType as string];
    if (!base) return "";
    const folder = `docs_${projectLower}`;

    return `/assets/docs/${folder}/${base}_${projectUpper}.pdf`;
  };

  return (
    <div
      {...rest}
      className={twMerge(
        "border border-[#E7EDEC] border-solid shadow-card rounded-[10px] px-4 py-8 flex flex-col items-center gap-8 w-full max-w-[454px]",
        className
      )}
    >
      <div>{Icon}</div>
      <h2 className="text-xl text-center font-extrabold">{title}</h2>
      <p className="text-center">{description}</p>
      <Button className="!w-full">
        <a
          href={getHref()}
          download
          className="w-full text-center flex gap-2 items-center justify-center"
        >
          <img
            src="/assets/svgs/icon-down-white.svg"
            alt="Ícone de Download"
            className="text"
          />
          Baixar
        </a>
      </Button>
    </div>
  );
};
